module.exports = __webpack_public_path__ + "static/media/favicon_old.d106401e.io";